import { InvitationsApi } from '@/services'
import Vue from 'vue'

const state = {
  invitations: [],
  isLoading: false,
  isLoaded: false
}

const mutations = {
  addInvitation(state, invitation) {
    state.invitations = [...state.invitations, invitation]
  },
  setInvitations(state, invitations) {
    state.invitations = invitations
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setLoaded(state, isLoaded) {
    state.isLoaded = isLoaded
  }
}

const actions = {
  async load({ commit, state }) {
    commit('setLoading', true)
    try {
      let practices = await InvitationsApi.all()
      commit('setInvitations', practices)
    } catch (err) {
      commit('setInvitations', [])
    }
    commit('setLoading', false)
    commit('setLoaded', true)
  },
  reset({ commit }) {
    commit('setLoaded', false)
    commit('setInvitations', [])
  },
  onAuthChange: ({ dispatch }, { isPracticeChanged, isNewUser }) => {
    if (isPracticeChanged) {
      dispatch('reset')
      if (isNewUser) dispatch('load')
    }
  },
  save: async ({ commit, rootState, dispatch }, { email, practice }) => {
    email = email || (practice && practice.email)
    const invitation = {
      practice_id: (practice && practice.id) || '',
      ...practice,
      email
    }
    delete invitation.id // we delete this so that a post will be made - we will never be PUT'ing an invite
    return InvitationsApi.save(invitation).then(result => {
      commit('addInvitation', result)
      return result
    })
  }
}

const getters = {
  byPracticeId: state => id =>
    state.invitations.filter(s => s.practice_id == id)
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
